import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Platform } from '@angular/cdk/platform';
import { Subscription } from 'rxjs';
import { ConsentService } from 'src/app/services/consent.service';
import { DialogContentExampleDialog } from './dialog-content/dialog-content-example-dialog';

export interface DialogData {
  analytics: boolean;
  ads: boolean;
}

// Bandeau cookies (monté une fois dans le layout PublicHomeComponent, donc présent sur toutes les pages)
@Component({
    selector: 'app-cookie-dialog',
    templateUrl: './cookie-dialog.component.html',
    styleUrls: ['./cookie-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CookieDialogComponent implements OnInit, OnDestroy {

  bannerVisible = false;
  private subscriptions = new Subscription();

  constructor(
    public consentService: ConsentService,
    private platform: Platform,
    public dialog: MatDialog) { }

  ngOnInit() {
    if (!this.consentService.isBrowser) {
      return;
    }
    this.subscriptions.add(this.consentService.bannerVisible$.subscribe(visible => this.bannerVisible = visible));
    this.subscriptions.add(this.consentService.preferencesRequested$.subscribe(() => this.openDialog()));
    // iOS (dont l'app installée) : bandeau non proposé d'office, aucun traceur chargé sans choix explicite ;
    // le lien « Gérer mes cookies » reste disponible
    this.consentService.init(!this.platform.IOS);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  accept(): void {
    this.consentService.acceptAll();
  }

  deny(): void {
    this.consentService.rejectAll();
  }

  openDialog() {
    if (this.dialog.openDialogs.some(d => d.componentInstance instanceof DialogContentExampleDialog)) {
      return;
    }
    const current = this.consentService.consent;
    const dialogRef = this.dialog.open(DialogContentExampleDialog, {
      data: { analytics: !!current?.analytics, ads: !!current?.ads },
      width: '560px',
      maxWidth: '95vw',
      autoFocus: false,
    });
    this.consentService.setBannerVisible(false);
    dialogRef.afterClosed().subscribe((result?: DialogData) => {
      if (result) {
        this.consentService.save(result);
      } else {
        this.consentService.setBannerVisible(true);
      }
    });
  }

}
